<div [hidden]="isInIframe">
    <div class="row" [hidden]="showStatusReport || displayMode !== DISPLAY_MODE_PROJECT">
        <div class="col-md-12" >
            <span [style]="'float:right;'">
                <button [matTooltip]="displaySortToolTip()" type="button" id="sortMenu" mat-raised-button
                [matMenuTriggerFor]="menu" [style]="'margin-left: 15px;'">Sort<mat-icon>menu</mat-icon></button>
            <mat-menu #menu="matMenu">
                <button type="button" mat-menu-item (click)="sortRecords('projectTitle','asc')">Project Title
                    ↑</button>
                <button type="button" mat-menu-item (click)="sortRecords('projectTitle','desc')">Project Title
                    ↓</button>
                <button type="button" mat-menu-item (click)="sortRecords('portfolio','asc')">Portfolio
                    ↑</button>
                <button type="button" mat-menu-item (click)="sortRecords('portfolio','desc')">Portfolio
                    ↓</button>
                <button type="button" mat-menu-item (click)="sortRecords('projectStatus','desc')">Project Status
                    ↑</button>
                <button type="button" mat-menu-item (click)="sortRecords('projectStatus','asc')">Project Status
                    ↓</button>
                <button type="button" mat-menu-item (click)="sortRecords('projectCategory','asc')">Project Category
                    ↑</button>
                <button type="button" mat-menu-item (click)="sortRecords('projectCategory','desc')">Project Category
                    ↓</button>


                <button type="button" mat-menu-item (click)="sortRecords('lastModifiedDateUTC','desc')">Last Update
                    ↓</button>
                <button type="button" mat-menu-item (click)="sortRecords('lastModifiedDateUTC','asc')"> Last Update
                    ↑</button>
            </mat-menu>
            </span>

            <so-menu-with-checkboxes class="" [options]="projectCategoryOptions" buttonText="Category" buttonColor="basic"
                menuClass="psmenu" (changeEvent)="updateSelectedProjectCategory($event)" [style]="'float:right;margin-left: 5px;'">
            </so-menu-with-checkboxes>
            <so-menu-with-checkboxes class="" [options]="portfolioOptions" buttonText="Portfolio" buttonColor="basic"
                menuClass="psmenu" (changeEvent)="updateSelectedPortfolio($event)" [style]="'float:right;margin-left: 5px;'">
            </so-menu-with-checkboxes>
            
            
            <so-menu-with-checkboxes [options]="projectStatusOptions" buttonText="Project Statuses" buttonColor="basic"
                menuClass="psmenu" (changeEvent)="updateSelectedProjectStatuses($event)" [style]="'float:right;margin-left: 5px;'">
            </so-menu-with-checkboxes>
            <so-menu-with-checkboxes class="" [options]="projectTypeOptions" buttonText="Project Types" buttonColor="basic"
                menuClass="psmenu" (changeEvent)="updateSelectedProjectTypes($event)" [style]="'float:right;'">
            </so-menu-with-checkboxes>
            <so-menu-with-checkboxes class="" [options]="wrNumberOptions" buttonText="Projects" buttonColor="basic"
                menuClass="psmenu" (changeEvent)="updateSelectedWrNumbers($event)" [style]="'float:right;'">
            </so-menu-with-checkboxes>

        </div>
    </div>

</div>
<mat-card [hidden]="!showDashboard || displayMode !== DISPLAY_MODE_PROJECT" class="card-container" [ngClass]="isInIframe === true ? 'iframecontainer' : 'notiframecontainer'">
    <mat-card-content class="card-body">
 
    <div class="row">
        <div class="col-md-6">
            <h1 class="mat-h2 left-text">{{projectHeader}}</h1>
        </div>
        
    </div>

    <div class="row outline" *ngIf="!isInIframe">
        <div class="col-md-2 col-width1 app-h3 long-text">Project</div>
        <div class="col-md-1 col-width2 app-h3">Status</div>
        <div class="col-md-2 col-width3 app-h3 long-text">Key Accomplishments</div>
        <div class="col-md-1 col-width4 app-h3 col-hdr4">Funding Source</div>
        <div class="col-md-2 col-width5 app-h3 col-hdr5">Governance</div>
        <div class="col-md-1 col-width6 app-h3 col-hdr6">Portfolio</div>
        <div class="col-md-2 col-width7 app-h3 col-hdr7">Category</div>
        <div class="col-md-1 col-width8 app-h3 col-hdr8">Business Sponsor</div>
        <div class="col-md-2 col-width9 app-h3">IT Lead</div>
        <div class="col-md-2 col-width10 app-h3">Project Manager</div>
    </div>

    <div class="row outline" *ngIf="isInIframe">
        <div class="col-md-2 col-width1 app-h3 long-text" matTooltip="Project">Project</div>
        <div class="col-md-1 col-width2 app-h3"></div>
        <div class="col-md-2 col-width3 app-h3 long-text">Key Accomplishments</div>
        <div class="col-md-1 col-width4 app-h3 col-hdr4" matTooltip="Funding Source">Fund Src</div>
        <div class="col-md-2 col-width5 app-h3 col-hdr5" matTooltip="Governance">Gov</div>
        <div class="col-md-1 col-width6 app-h3 col-hdr6" matTooltip="Portfolio">Port</div>
        <div class="col-md-2 col-width7 app-h3 col-hdr7" matTooltip="Category">Cat</div>
        <div class="col-md-1 col-width8 app-h3 col-hdr8" matTooltip="Business Sponsor">Bus Sp</div>
        <div class="col-md-2 col-width9 app-h3">IT Lead</div>
        <div class="col-md-2 col-width10 app-h3">Project Manager</div>
    </div>
        
    <!--(click)="goto(rec)" -->
    <div *ngFor="let type of projectTypes; index as i; first as isFirst">
        <div *ngIf="projectTypes[i] !== 'Other'">
            <div class="project-type">{{projectTypes[i]}}</div>
            <div *ngFor="let rec of filteredWorkRequests; ">
    
                <div class="row outline" *ngIf="rec.projectType === projectTypes[i]">
                    <div class="col-md-2 col-width1 col-text" (click)="goto(rec)" matTooltipClass="wrNumberTooktip"
                        [matTooltip]="getWRTooltip(rec)" matTooltipPosition="right">{{rec.projectTitle || rec.wrNumber}}
                    </div>
                    <div class="col-md-1 col-width2 {{rec.projectStatus}} col-text" (click)="gotoStatus($event,rec)"
                        matTooltip="click to view status report" matTooltipPosition="right">
                        {{projectStatusObj[rec.projectStatus!].short}}</div>
                    <div class="col-md-2 col-width3 col-text" (click)="gotoStatus($event,rec)"
                        [innerHTML]="rec.keyAccomplishments"></div>
                    <div class="col-md-1 col-width4 col-text" title="{{getTooltip(rec,'fundingSource')}}" (click)="gotoStatus($event,rec)">{{rec.fundingSource}}</div>
                    <div class="col-md-2 col-width5 col-text" title="{{getTooltip(rec,'projectGovernance')}}" (click)="gotoStatus($event,rec)">{{rec.projectGovernance}}</div>
                    <div class="col-md-1 col-width6 col-text" title="{{getTooltip(rec,'portfolio')}}" (click)="gotoStatus($event,rec)">{{rec.portfolio}}</div>
                    <div class="col-md-2 col-width7 col-text" title="{{getTooltip(rec,'projectCategory')}}" (click)="gotoStatus($event,rec)">{{rec.projectCategory}}</div>
                    <div class="col-md-1 col-width8 col-text" title="{{getTooltip(rec,'businessSponsor')}}" (click)="gotoStatus($event,rec)">{{rec.businessSponsor}}</div>
                    <div class="col-md-2 col-width9 col-text" (click)="gotoStatus($event,rec)"
                        [innerHTML]="rec.projectItLead | azureName"></div>
                    <div class="col-md-2 col-width10 col-text" (click)="gotoStatus($event,rec)"
                        [innerHTML]="rec.projectManager | azureName"></div>
                </div>
            </div>
            <div [hidden]="projectTypeCount[projectTypes[i]] !==0" class="row outline" >
                <div class="col-md-12 col-text" >no in-progress {{projectTypes[i]}} projects found. </div>
            </div> 
        </div>
        </div>
        <div *ngFor="let type of projectTypes; index as i; first as isFirst">
        <div *ngIf="projectTypes[i] === 'Other'">
            <div class="project-type">Other</div>
            <div *ngFor="let rec of filteredWorkRequests;">
    
                <div class="row outline" *ngIf="rec.projectType === projectTypes[i]">
                    <div class="col-md-2 col-width1 col-text" (click)="goto(rec)" matTooltipClass="wrNumberTooktip"
                        [matTooltip]="getWRTooltip(rec)" matTooltipPosition="right">{{rec.projectTitle || rec.wrNumber}}
                    </div>
                    <div class="col-md-1 col-width2 {{rec.projectStatus}} col-text" (click)="gotoStatus($event,rec)"
                        matTooltip="click to view status report" matTooltipPosition="right">
                        {{projectStatusObj[rec.projectStatus!].short}}</div>
                    <div class="col-md-2 col-width3 col-text" (click)="gotoStatus($event,rec)"
                        [innerHTML]="rec.keyAccomplishments"></div>
                    <div class="col-md-1 col-width4 col-text" title="{{getTooltip(rec,'fundingSource')}}" (click)="gotoStatus($event,rec)">{{rec.fundingSource}}</div>
                    <div class="col-md-2 col-width5 col-text" title="{{getTooltip(rec,'projectGovernance}}"(click)="gotoStatus($event,rec)">{{rec.projectGovernance}}</div>
                    <div class="col-md-1 col-width6 col-text" title="{{getTooltip(rec,'portfolio)}}" (click)="gotoStatus($event,rec)">{{rec.portfolio}}</div>
                    <div class="col-md-2 col-width7 col-text" title="{{getTooltip(rec,'projectCategory}}" (click)="gotoStatus($event,rec)">{{rec.projectCategory}}</div>
                    <div class="col-md-1 col-width8 col-text" title="{{getTooltip(rec,'businessSponsor')}}" (click)="gotoStatus($event,rec)">{{rec.businessSponsor}}</div>
                    <div class="col-md-2 col-width9 col-text" (click)="gotoStatus($event,rec)"
                        [innerHTML]="rec.projectItLead | azureName" ></div>
                    <div class="col-md-2 col-width10 col-text" (click)="gotoStatus($event,rec)"
                        [innerHTML]="rec.projectManager | azureName"></div>
                </div>

            </div>

        </div>
    </div>
    <!--
    <div class="project-type">Priority Initiatives</div>
    <div [hidden]="priorityWorkRequests.length === 0"   class="row outline"  *ngFor="let rec of priorityWorkRequests; index as i; first as isFirst" >
        <div class="col-md-2 col-width1 col-text" (click)="goto(rec)"  matTooltipClass="wrNumberTooktip" [matTooltip]="getWRTooltip(rec)" matTooltipPosition="right">{{rec.projectTitle  || rec.wrNumber}}</div>
        <div class="col-md-1 col-width2 {{rec.projectStatus}} col-text" (click)="gotoStatus($event,rec)" matTooltip="click to view status report" matTooltipPosition="right">{{projectStatusObj[rec.projectStatus!].short}}</div>
        <div class="col-md-2 col-width3 col-text" (click)="gotoStatus($event,rec)" [innerHTML]="rec.keyAccomplishments"></div>
        <div class="col-md-1 col-width4 col-text" (click)="gotoStatus($event,rec)">{{rec.fundingSource}}</div>
        <div class="col-md-2 col-width5 col-text" (click)="gotoStatus($event,rec)">{{rec.projectGovernance}}</div>
        <div class="col-md-1 col-width6 col-text" (click)="gotoStatus($event,rec)">{{rec.businessSponsor}}</div>
        <div class="col-md-2 col-width7 col-text" (click)="gotoStatus($event,rec)" [innerHTML]="rec.projectItLead | azureName" [style]="'flex:12%;max-width:12%'"></div>
        <div class="col-md-2 col-width8 col-text" (click)="gotoStatus($event,rec)" [innerHTML]="rec.projectManager | azureName" [style]="'flex:12%;max-width:12%'"></div>      
    </div>
    <div [hidden]="priorityWorkRequests.length !== 0" class="row outline" >
        <div class="col-md-12 col-text" >no in-progress priority initiatives found. </div>
    </div>  

    <div class="project-type">Operations</div>
    <div [hidden]="operationsWorkRequests.length === 0"  class="row outline" *ngFor="let rec of operationsWorkRequests; index as i; first as isFirst">
        <div class="col-md-2 col-width1 col-text" (click)="goto(rec)"  matTooltipClass="wrNumberTooktip" [matTooltip]="getWRTooltip(rec)" matTooltipPosition="right">{{rec.projectTitle ||rec.wrNumber}}</div>
        <div  class="col-md-1 col-width2 {{rec.projectStatus}} col-text" (click)="gotoStatus($event, rec)" matTooltip="click to view status report" matTooltipPosition="right" >{{projectStatusObj[rec.projectStatus!].short}}</div>
        <div class="col-md-2 col-width3 col-text" (click)="gotoStatus($event,rec)" [innerHTML]="rec.keyAccomplishments"></div>
        <div class="col-md-1 col-width4 col-text" (click)="gotoStatus($event,rec)">{{rec.fundingSource}}</div>
        <div class="col-md-2 col-width5 col-text" (click)="gotoStatus($event,rec)">{{rec.projectGovernance}}</div>
        <div class="col-md-1 col-width6 col-text" (click)="gotoStatus($event,rec)">{{rec.businessSponsor}}</div>
        <div class="col-md-2 col-width7 col-text" (click)="gotoStatus($event,rec)" [innerHTML]="rec.projectItLead | azureName" [style]="'flex:12%;max-width:12%'"></div>
        <div class="col-md-2 col-width8 col-text" (click)="gotoStatus($event,rec)" [innerHTML]="rec.projectManager | azureName" [style]="'flex:12%;max-width:12%'"></div>       
    </div>  
    <div [hidden]="operationsWorkRequests.length !== 0" class="row outline" >
        <div class="col-md-12 col-text" >no in-progress operations projects found. </div>
    </div>  

    <div [hidden]="otherWorkRequests.length === 0">
        <div class="project-type">Other</div>
        <div class="row outline" *ngFor="let rec of otherWorkRequests; index as i; first as isFirst">
            <div class="col-md-2 col-width1 col-text" (click)="goto(rec)"  matTooltipClass="wrNumberTooktip" [matTooltip]="getWRTooltip(rec)" matTooltipPosition="right" >{{rec.projectTitle || rec.wrNumber}}
            </div>
            <div class="col-md-1 col-width2 {{rec.projectStatus}} col-text" (click)="gotoStatus($event,rec)" matTooltip="click to view status report" matTooltipPosition="right" >{{projectStatusObj[rec.projectStatus!].short}}
            </div>
            <div class="col-md-2 col-width3 col-text" (click)="gotoStatus($event,rec)" [innerHTML]="rec.keyAccomplishments"></div>
            <div class="col-md-1 col-width4 col-text" (click)="gotoStatus($event,rec)">{{rec.fundingSource}}</div>
            <div class="col-md-2 col-width5 col-text" (click)="gotoStatus($event,rec)">{{rec.projectGovernance}}</div>
            <div class="col-md-1 col-width6 col-text" (click)="gotoStatus($event,rec)">{{rec.businessSponsor}}</div>
            <div class="col-md-2 col-width7 col-text" (click)="gotoStatus($event,rec)" [innerHTML]="rec.projectItLead | azureName" [style]="'flex:12%;max-width:12%'"></div>
            <div class="col-md-2 col-width8 col-text" (click)="gotoStatus($event,rec)" [innerHTML]="rec.projectManager | azureName" [style]="'flex:12%;max-width:12%'"></div>
        </div>
    </div>
    -->
    <div class="legend-div">
        <b>Legend |
            <span class="on-plan legend">&nbsp;G&nbsp;</span> On Plan
            <span class="behind-plan legend">&nbsp;Y&nbsp;</span> Behind Plan
            <span class="significantly-behind-plan legend ">&nbsp;R&nbsp;</span> Significantly Behind Plan
            <span class="completed legend">&nbsp;C&nbsp;</span> Completed
            <span class="not-started legend">&nbsp;N&nbsp;</span> Not Started
            <span class="pre-planning legend">&nbsp;P&nbsp;</span> Pre-planning / Pilot
        </b>
        <span class="info">Click on any row to view the project status report. Click in the portfolio column to view project details.
            <mat-icon matTooltip="click for additional instructions to screenshot the dashboard."
                (click)="soModalService.open('modal-screenshot')" [inline]="true">info</mat-icon>
        
        </span>

        <so-modal id="modal-screenshot">
            <so-snapshot></so-snapshot>
        </so-modal>
    </div>


    </mat-card-content>
</mat-card>
<mat-card [hidden]="!showDashboard || displayMode !== DISPLAY_MODE_PROJECT_LIST" class="card-container" [ngClass]="isInIframe === true ? 'iframecontainer' : 'notiframecontainer'">


    <mat-card-content class="card-body">
 
    <div class="row">
        <div class="col-sm-6">
            <h1 class="mat-h2 left-text">{{projectHeader}}</h1>
        </div>
   
    </div>

    <div class="row outline">        
        <div class="list-col-width1 app-h3 long-text">Portfolio</div>
        <div class="list-col-width2 app-h3 long-text">Description</div>
        <div class="list-col-width3 app-h3">Status</div>
    </div>

    <!--(click)="goto(rec)" -->
    <div *ngFor="let type of projectTypes; index as i; first as isFirst">
        <div *ngIf="projectTypes[i] !== 'Other'">
            <div class="project-type">{{projectTypes[i]}}</div>
            <div *ngFor="let rec of filteredWorkRequests;">
    
                <div class="row outline" *ngIf="rec.projectType === projectTypes[i]">
                    <div class="list-col-width1 col-text" (click)="goto(rec)" matTooltipClass="wrNumberTooktip"
                        [matTooltip]="getWRTooltip(rec)" matTooltipPosition="right">{{rec.projectTitle || rec.wrNumber}}
                    </div>
                    <div class="list-col-width2 col-text" (click)="gotoStatus($event,rec)"
                        [innerHTML]="rec.projectDescription"></div>
                    <div class="list-col-width3  {{rec.projectStatus}} col-text" (click)="gotoStatus($event,rec)"
                        matTooltip="click to view status report" matTooltipPosition="right">
                        {{projectStatusObj[rec.projectStatus!].short}}</div>
                </div>
            </div>
            <div [hidden]="projectTypeCount[projectTypes[i]] !==0" class="row outline" >
                <div class="col-sm-12 col-text" >no in-progress {{projectTypes[i]}} projects found. </div>
            </div> 
        </div>
        </div>
        <div *ngFor="let type of projectTypes; index as i; first as isFirst">
        <div *ngIf="projectTypes[i] === 'Other'">
            <div class="project-type">Other</div>
            <div *ngFor="let rec of filteredWorkRequests;">
    
                <div class="row outline" *ngIf="rec.projectType === projectTypes[i]">
                    <div class="list-col-width1 col-text" (click)="goto(rec)" matTooltipClass="wrNumberTooktip"
                        [matTooltip]="getWRTooltip(rec)" matTooltipPosition="right">{{rec.projectTitle || rec.wrNumber}}
                    </div>
                    <div class="list-col-width2 col-text" (click)="gotoStatus($event,rec)"
                        [innerHTML]="rec.projectDescription"></div>
                    <div class="list-col-width3 {{rec.projectStatus}} col-text" (click)="gotoStatus($event,rec)"
                        matTooltip="click to view status report" matTooltipPosition="right">
                        {{projectStatusObj[rec.projectStatus!].short}}</div>
                </div>

            </div>

        </div>
    </div>
 
    <div class="legend-div">
        <b>Legend |
            <span class="on-plan legend">&nbsp;G&nbsp;</span> On Plan
            <span class="behind-plan legend">&nbsp;Y&nbsp;</span> Behind Plan
            <span class="significantly-behind-plan legend ">&nbsp;R&nbsp;</span> Significantly Behind Plan
            <span class="completed legend">&nbsp;C&nbsp;</span> Completed
            <span class="not-started legend">&nbsp;N&nbsp;</span> Not Started
            <span class="pre-planning legend">&nbsp;P&nbsp;</span> Pre-planning / Pilot
        </b>
        <span class="info">Click on any row to view the project status report. Click in the portfolio column to view project details.
            <mat-icon matTooltip="click for additional instructions to screenshot the dashboard."
                (click)="soModalService.open('modal-screenshot2')" [inline]="true">info</mat-icon>
        
        </span>

        <so-modal id="modal-screenshot2">
            <so-snapshot></so-snapshot>
        </so-modal>
    </div>


    </mat-card-content>

</mat-card>
<app-work-request-status  *ngIf="showStatusReport" [inputWorkRequest]="currentWorkRequest" (closingCompoment)="closeStatusReport($event, false)"></app-work-request-status>